import ProductDetails from "./default";
export default ProductDetails;
